import { useCallback } from 'react';

import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import {
  detailActions,
  detailSelectors,
} from 'store/reducers/crawlerReducer/detailSlice';
import { useToast } from 'hooks/useToast';
import * as crawlerApi from 'api/crawlerApi';

export const useDeleteDetailStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const selectedCrawler = useAppSelector(detailSelectors.selectedCrawler);
  const selectedCrawlerDetails = useAppSelector(
    detailSelectors.selectedCrawlerDetails,
  );
  const [selectedCrawlerDetail] = selectedCrawlerDetails;
  const isOpenModal = useAppSelector(detailSelectors.isOpenModalDeleteDetail);

  const onCloseModal = useCallback(() => {
    dispatch(detailActions.updateIsOpenModalDeleteDetail(false));
  }, [dispatch]);

  const onDeleteCrawlerDetail = useCallback(() => {
    if (selectedCrawler && selectedCrawlerDetail) {
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(detailActions.updateLoadingStatus(true));
        const result = await crawlerApi.deleteCrawlerDetail(
          selectedCrawler.id,
          selectedCrawlerDetail.version,
        );
        if (result.ok) {
          toast({
            status: 'success',
            description: `バージョンを削除しました。`,
          });

          const restCrawlerDetails = selectedCrawlerDetails.filter(
            ({ version }) => version !== selectedCrawlerDetail.version,
          );
          dispatch(detailActions.updateSelectedDetails(restCrawlerDetails));

          onCloseModal();
        } else {
          toast({
            status: 'error',
            description: `バージョンの削除に失敗しました。`,
          });
        }
        dispatch(detailActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `バージョンの削除に失敗しました。`,
        });
      });
    }
  }, [
    dispatch,
    onCloseModal,
    selectedCrawler,
    selectedCrawlerDetails,
    selectedCrawlerDetail,
    toast,
  ]);

  return {
    /** 削除対象のバージョン */
    crawlerDetail: selectedCrawlerDetail,
    /** クローラーバージョン履歴の確認モーダルの表示状態 */
    isOpenModal,
    /** クローラーバージョン履歴の更新キャンセル */
    onCloseModal,
    /** クローラーバージョン削除 */
    onDeleteCrawlerDetail,
  };
};
